import { useState } from 'react';
import { toast } from 'react-toastify';
import Modal from '../../../components/Modal';
import message from '../../../constant/message';
import Button from '../../../components/Common/Button';
import LenderUgroService from '../../../services/lender';
import { objectsForEach } from '../../../common/objectToArray';


const AddBtDataModal = ({ state, toggleModal, leadId, selectedLender, reloadTable, data, editBtDrf, companyDetails }) => {
    const [loading, setLoading] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [accType, setAccType] = useState(data?.acc_type)
    const [accName, setAccName] = useState(!editBtDrf ? (selectedLender == 21 ? '' : companyDetails?.company_name) : data?.acc_name)
    const [bankName, setBankName] = useState(data?.bank_name)
    const [chequeBankName, setChequeBankName] = useState(data?.bank_name)
    const [bankBranch, setBankBranch] = useState(data?.bank_branch)
    const [ifscCode, setIfscCode] = useState(data?.ifsc)
    const [bankAccID, SetBankAccID] = useState(data?.bank_acc_id)
    const [paymentMode, setPaymentMode] = useState(data?.txn_type)
    const [chequeNumber, setChequeNumber] = useState(data?.cheque_no)
    const [transferTo, setTransferTo] = useState(data?.disbursal_to)
    const [transferAmount, setTransferAmount] = useState(data?.finance_amount)
    const [drfType, setDrfType] = useState(data?.drf_type)
    const [errors, setErrors] = useState();

    const toggleConfirmModal = () => {
        setShowConfirmModal(!showConfirmModal);
    };

    const fetchBankDetailsByIfsc = (ifsc) => {
        fetch(`https://ifsc.razorpay.com/${ifsc}`)
            .then(response => response.json())
            .then(data => {
                setBankName(data?.BANK)
                setBankBranch(data?.BRANCH)
            })
            .catch(error => console.error('Error:', error));
    }

    const formSubmitHandler = async () => {
        setLoading(true);
        let formData = new FormData();
        formData.append('disbursal_to', transferTo)
        transferAmount && formData.append('finance_amount', transferAmount)
        paymentMode && formData.append('txn_type', paymentMode)
        formData.append('is_bt_case', 1)
        editBtDrf && formData.append('id', data?.id)
        accName && formData.append('acc_name', accName)
        bankName && formData.append('bank_name', bankName)
        ifscCode && formData.append('ifsc', ifscCode)
        bankAccID && formData.append('bank_acc_id', bankAccID)
        drfType && formData.append('drf_type', drfType)
        if (paymentMode == "NEFT") {
            accType && formData.append('acc_type', accType)
            bankBranch && formData.append('bank_branch', bankBranch)
        } else if (paymentMode == "Cheque") {
            chequeNumber && formData.append('cheque_no', chequeNumber)
        } else {
            toast.error("Please fill the required fields")
            toggleConfirmModal()
            setLoading(false)
            return;
        }

        await LenderUgroService.SaveDrfDetail({ formData, leadId, lenderId:selectedLender }).then((response) => {
            setLoading(false)
            toast.success(response?.data?.messages?.success?.others[0])
            toggleModal();
            setShowConfirmModal(false);
            reloadTable(leadId);
        }).catch((err) => {
            setLoading(false)
            setShowConfirmModal(false);
            toast.error(err?.response?.data?.messages?.error?.form?.[0] || err?.response?.data?.messages?.error?.others?.[0])
            setErrors(err?.response?.data?.messages?.error?.fields)
        });
    }

    return (
        <>
            <Modal state={state} closeModal={toggleModal} style={{ width: "450px" }} removeBorderSpace={true} closeOnOverlayClick={false}>
                <div className="modal-header-container">
                    <div className="modal-title">Bank/Customer Transfer Details</div>
                    <div className="closeModalView" onClick={toggleModal}>
                        <span className="closeModalIcon">x</span>
                    </div>
                </div>
                <div className="p-4 modalData">
                    <div style={{ maxHeight: '400px', overflowY: 'scroll', overflowX: 'clip' }}>
                        <div class='form-group'>
                            <label>Disbursal To <tt>*</tt></label>
                            <div class='row'>
                                <div class='col-12'>
                                    <select
                                        class='form-control custom-form-control'
                                        onChange={(e) => setTransferTo(e.target.value)}
                                        value={transferTo}
                                    >
                                        <option value={''}>Please Select</option>
                                        <option value={"1"}>{"Bank"}</option>
                                        <option value={"0"}>{"Customer"}</option>
                                    </select>
                                </div>
                                {errors && (
                                    <p className='mb-0 text-danger' style={{ margin: '-8px 0 0 17px' }}>{errors?.disbursal_to?.[0]}</p>
                                )}
                            </div>
                        </div>
                        <div class='form-group'>
                            <label>Transfer Amount <tt>*</tt></label>
                            <div class='row'>
                                <div class='col-12'>
                                    <input
                                        class='form-control custom-form-control'
                                        value={transferAmount}
                                        name="finance_amount"
                                        onChange={(e) => setTransferAmount(e.target.value)}
                                        maxLength={50}
                                        required
                                    />
                                </div>
                                {errors && (
                                    <p className='mb-0 text-danger' style={{ margin: '-8px 0 0 17px' }}>{errors?.finance_amount?.[0]}</p>
                                )}
                            </div>
                        </div>
                        <div class='form-group'>
                            <label>Payment Mode <tt>*</tt></label>
                            <div class='row'>
                                <div class='col-12'>
                                    <select
                                        class='form-control custom-form-control'
                                        onChange={(e) => setPaymentMode(e.target.value)}
                                        value={paymentMode}
                                    >
                                        <option value={''}>Please Select</option>
                                        <option value={"NEFT"}>{"NEFT/RTGS"}</option>
                                        <option value={"Cheque"}>{"Cheque"}</option>
                                    </select>
                                </div>
                                {errors && (
                                    <p className='mb-0 text-danger' style={{ margin: '-8px 0 0 17px' }}>{errors?.txn_type?.[0]}</p>
                                )}
                            </div>
                        </div>
                        {paymentMode == "NEFT" &&
                            <>
                                <div class='form-group'>
                                    <label>Account Type <tt>*</tt></label>
                                    <div class='row'>
                                        <div class='col-12'>
                                            <select
                                                class='form-control custom-form-control'
                                                onChange={(e) => setAccType(e.target.value)}
                                                value={accType}
                                            >
                                                <option value={''}>Please Select</option>
                                                <option value={"Saving"}>{"Saving"}</option>
                                                <option value={"Current"}>{"Current"}</option>
                                            </select>
                                        </div>
                                        {errors && (
                                            <p className='mb-0 text-danger' style={{ margin: '-8px 0 0 17px' }}>{errors?.acc_type?.[0]}</p>
                                        )}
                                    </div>
                                </div>
                                <div class='form-group'>
                                    <label>Account Holder's Name <tt>*</tt></label>
                                    <div class='row'>
                                        <div class='col-12'>
                                            <input
                                                class='form-control custom-form-control'
                                                value={accName}
                                                name="acc_name"
                                                onChange={(e) => setAccName(e.target.value)}
                                                maxLength={50}
                                                required
                                            />
                                        </div>
                                        {errors && (
                                            <p className='mb-0 text-danger' style={{ margin: '-8px 0 0 17px' }}>{errors?.acc_name?.[0]}</p>
                                        )}
                                    </div>
                                </div>
                                <div class='form-group'>
                                    <label>Bank Account No. <tt>*</tt></label>
                                    <div class='row'>
                                        <div class='col-12'>
                                            <input
                                                class='form-control custom-form-control'
                                                value={bankAccID}
                                                name="acc_number"
                                                onChange={(e) => SetBankAccID(e.target.value)}
                                                maxLength={50}
                                                required
                                            />
                                        </div>
                                        {errors && (
                                            <p className='mb-0 text-danger' style={{ margin: '-8px 0 0 17px' }}>{errors?.bank_acc_id?.[0]}</p>
                                        )}
                                    </div>
                                </div>
                                <div class='form-group'>
                                    <label>Bank IFSC <tt>*</tt></label>
                                    <div class='row'>
                                        <div class='col-12'>
                                            <input
                                                class='form-control custom-form-control'
                                                value={ifscCode}
                                                name="ifsc"
                                                onChange={(e) => {
                                                    setIfscCode(e.target.value.toUpperCase())
                                                    if (e.target.value.length > 10) {
                                                        fetchBankDetailsByIfsc(e.target.value)
                                                    }
                                                }}
                                                maxLength={11}
                                                required
                                            />
                                        </div>
                                        {errors && (
                                            <p className='mb-0 text-danger' style={{ margin: '-8px 0 0 17px' }}>{errors?.ifsc?.[0]}</p>
                                        )}
                                    </div>
                                </div>
                                <div class='form-group'>
                                    <label>Bank Name <tt>*</tt></label>
                                    <div class='row'>
                                        <div class='col-12'>
                                            <input
                                                class='form-control custom-form-control'
                                                value={bankName}
                                                name="bank_name"
                                                onChange={(e) => setBankName(e.target.value)}
                                                maxLength={50}
                                                required
                                            />
                                        </div>
                                        {errors && (
                                            <p className='mb-0 text-danger' style={{ margin: '-8px 0 0 17px' }}>{errors?.bank_name?.[0]}</p>
                                        )}
                                    </div>
                                </div>
                                <div class='form-group'>
                                    <label>Bank Branch<tt>*</tt></label>
                                    <div class='row'>
                                        <div class='col-12'>
                                            <input
                                                class='form-control custom-form-control'
                                                value={bankBranch}
                                                name="bank_branch"
                                                onChange={(e) => setBankBranch(e.target.value)}
                                                maxLength={50}
                                                required
                                            />
                                        </div>
                                        {errors && (
                                            <p className='mb-0 text-danger' style={{ margin: '-8px 0 0 17px' }}>{errors?.bank_branch?.[0]}</p>
                                        )}
                                    </div>
                                </div>
                            </>
                        }
                        {paymentMode == "Cheque" &&
                            <>
                                <div class='form-group'>
                                    <label>Account Holder's Name <tt>*</tt></label>
                                    <div class='row'>
                                        <div class='col-12'>
                                            <input
                                                class='form-control custom-form-control'
                                                value={accName}
                                                name="acc_name"
                                                onChange={(e) => setAccName(e.target.value)}
                                                maxLength={50}
                                                required
                                            />
                                        </div>
                                        {errors && (
                                            <p className='mb-0 text-danger' style={{ margin: '-8px 0 0 17px' }}>{errors?.acc_name?.[0]}</p>
                                        )}
                                    </div>
                                </div>
                                <div class='form-group'>
                                    <label>Bank Account No. <tt>*</tt></label>
                                    <div class='row'>
                                        <div class='col-12'>
                                            <input
                                                class='form-control custom-form-control'
                                                value={bankAccID}
                                                name="acc_number"
                                                onChange={(e) => SetBankAccID(e.target.value)}
                                                maxLength={50}
                                                required
                                            />
                                        </div>
                                        {errors && (
                                            <p className='mb-0 text-danger' style={{ margin: '-8px 0 0 17px' }}>{errors?.bank_acc_id?.[0]}</p>
                                        )}
                                    </div>
                                </div>
                                <div class='form-group'>
                                    <label>Bank IFSC</label>
                                    <div class='row'>
                                        <div class='col-12'>
                                            <input
                                                class='form-control custom-form-control'
                                                value={ifscCode}
                                                name="ifsc"
                                                onChange={(e) => {
                                                    setIfscCode(e.target.value.toUpperCase())
                                                    if (e.target.value.length > 10) {
                                                        fetchBankDetailsByIfsc(e.target.value)
                                                    }
                                                }}
                                                maxLength={11}
                                                required
                                            />
                                        </div>
                                        {errors && (
                                            <p className='mb-0 text-danger' style={{ margin: '-8px 0 0 17px' }}>{errors?.ifsc?.[0]}</p>
                                        )}
                                    </div>
                                </div>
                                <div class='form-group'>
                                    <label>Bank Name <tt>*</tt></label>
                                    <div class='row'>
                                        <div class='col-12'>
                                            <input
                                                class='form-control custom-form-control'
                                                value={bankName}
                                                name="bank_name"
                                                onChange={(e) => setBankName(e.target.value)}
                                                maxLength={50}
                                                required
                                            />
                                        </div>
                                        {errors && (
                                            <p className='mb-0 text-danger' style={{ margin: '-8px 0 0 17px' }}>{errors?.bank_name?.[0]}</p>
                                        )}
                                    </div>
                                </div>
                                <div class='form-group'>
                                    <label>Cheque Number</label>
                                    <div class='row'>
                                        <div class='col-12'>
                                            <input
                                                class='form-control custom-form-control'
                                                value={chequeNumber}
                                                name="cheque_no"
                                                onChange={(e) => setChequeNumber(e.target.value)}
                                                maxLength={15}
                                                required
                                            />
                                        </div>
                                        {errors && (
                                            <p className='mb-0 text-danger' style={{ margin: '-8px 0 0 17px' }}>{errors?.cheque_no?.[0]}</p>
                                        )}
                                    </div>
                                </div>
                            </>
                        }
                        {selectedLender == 21 &&
                            <div class='form-group'>
                                <label>DRF Type<tt>*</tt></label>
                                <div class='row'>
                                    <div class='col-12' style={{ display: 'inline-flex'}}>
                                        <input
                                            className='mr-2'
                                            type="radio" 
                                            id="tranche" 
                                            checked={drfType == 2}
                                            onChange={(e) => setDrfType(e.target.value)}
                                            name="drf_type" 
                                            value="2" 
                                        />
                                        <label for="tranche" style={{ marginTop:'5px' }}>Tranche</label>
                                        <div style={{ width:'50px' }}></div>
                                        <input
                                            className='mr-2' 
                                            type="radio" 
                                            id="onetime" 
                                            checked={drfType == 1}
                                            onChange={(e) => setDrfType(e.target.value)}
                                            name="drf_type" 
                                            value="1" 
                                        />
                                        <label for="onetime" style={{ marginTop:'5px' }}>One Time</label>
                                    </div>
                                    {errors && (
                                        <p className='mb-0 text-danger' style={{ margin: '-8px 0 0 17px' }}>{errors?.drf_type?.[0]}</p>
                                    )}
                                </div>
                            </div>
                        }
                    </div>
                    <div class='d-flex align-items-center justify-content-center mt-2'>
                        <button type='submit' class='btn btn-custom' disabled={loading} onClick={toggleConfirmModal}>
                            Save
                        </button>
                        <button
                            type='button'
                            class='btn btn-outline-custom ml-2'
                            data-dismiss='modal'
                            onClick={toggleModal}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </Modal>
            <Modal state={showConfirmModal} closeModal={toggleConfirmModal} style={{ width: '440px' }}>
                <div>
                    <p className='font-weight-bold text-center'>
                        Disbursement will be done as per the shared Bank Account Details. Please confirm to save the Bank Transfer Account details.
                    </p>
                    <br />
                    <div className='d-flex align-items-center justify-content-center'>
                        <Button clickHandler={formSubmitHandler} classNames='btn-custom small mr-2' disabled={loading}>
                            {loading ? <div className='loader' /> : 'Yes'}
                        </Button>
                        <Button
                            clickHandler={toggleConfirmModal}
                            classNames='btn-custom small'
                        >
                            No
                        </Button>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default AddBtDataModal;
